<template>
  <div class="collection-item-information">
    <div class="collection-item collection-item-video" v-if="isCollectionType('video')">
      <div class="title">
        {{getTitle(collectionItem.type, collectionItem)}}
      </div>
      <small>
        แก้ไขล่าสุด {{formatDateTime(collectionItem.video.updatedAt)}}
      </small>
      <div class="taxonomy">
        {{getTaxonomy(collectionItem.type, collectionItem)}}
      </div>
    </div>
    <div class="collection-item collection-item-episode" v-if="isCollectionType('episode')">
      <div class="title">
        {{getTitle(collectionItem.type, collectionItem)}}
      </div>
      <div class="subtitle">
        {{getSubtitleByFieldName(collectionItem.type, collectionItem, 'episode.title')}}
      </div>
      <small>
        ออกอากาศ {{formatDateTime(collectionItem.episode.updatedAt)}}
      </small>
      <div class="taxonomy">
        {{getTaxonomy(collectionItem.type, collectionItem)}}
      </div>
    </div>
    <div class="collection-item collection-item-program" v-if="isCollectionType('program')">
      <div class="title">
        {{getTitle(collectionItem.type, collectionItem)}}
      </div>
      <div class="subtitle">
        {{getSubtitleByFieldName(collectionItem.type, collectionItem, 'program.schedule')}}
      </div>
      <small>
        แก้ไขล่าสุด {{formatDateTime(collectionItem.program.updatedAt)}}
      </small>
      <div class="taxonomy">
        {{getTaxonomy(collectionItem.type, collectionItem)}}
      </div>
    </div>
    <div class="collection-item collection-item-program" v-if="isCollectionType('playlist')">
      <div class="title">
        {{getTitle(collectionItem.type, collectionItem)}}
      </div>
      <div class="subtitle">
        {{getSubtitleByFieldName(collectionItem.type, collectionItem, 'playlist.schedule')}}
      </div>
      <small>
        แก้ไขล่าสุด {{formatDateTime(collectionItem.playlist.updatedAt)}}
      </small>
      <div class="taxonomy">
        {{getTaxonomy(collectionItem.type, collectionItem)}}
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import dateFormetter from '@/utils/dateFormatter';

export default {
  mixins: [dateFormetter],
  props: {
    isDragable: {
      type: Boolean,
      default: false,
    },
    collectionItem: {
      type: Object,
      default: () => {},
    },
    collectionType: {
      type: String,
      default: 'Video',
    },
  },
  methods: {
    isCollectionType(typeName) {
      return this.collectionType.toLowerCase() === typeName;
    },
    getTitle(type, collectionItem) {
      return _.get(collectionItem[type], 'title', 'ไม่มีข้อมูล');
    },
    getSubtitleByFieldName(type, collectionItem, fieldName) {
      return _.get(collectionItem[type], fieldName, '');
    },
    getTaxonomy(type, collectionItem) {
      return _.get(collectionItem[type], 'contentCategory.name', 'ไม่มีหมวดหมู่');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';


.title {
  color: $gray-700;
  font-weight: bold;
}

.taxonomy {
  color: $gray-500;
  font-size: $font-size-base * 0.875;
}
</style>
